<div class="modal-etapa">
  <div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined" [style.color]="cor">{{ icone }}</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h2 class="modal-title">{{ nome || 'Informe o nome da coluna' }}</h2>
      <p class="modal-subtitle">{{ isNova ? 'Nova etapa' : 'Editar etapa' }}</p>
    </div>
    <div class="modal-header-close-btn-container">
      <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
        (click)="fechar()">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-content">

    @if (isCarregando) {
    <div class="modal-loading">
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
      <app-loading-box height="60" margin="0 0 16px 0"></app-loading-box>
    </div>
    } @else {

    <!-- 1. Identidade -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">1</span>
        <mat-icon class="material-symbols-outlined">badge</mat-icon>
        <span>Identidade</span>
      </div>
      <p class="section-sub-title">Como esta etapa aparece no board de oportunidades.</p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Nome da coluna</mat-label>
        <input matInput [(ngModel)]="nome" [disabled]="isNomeBloqueado" [maxlength]="NOME_MAX_LENGTH"
          placeholder="Ex.: Qualificação" required />
        @if (isNomeBloqueado) {
        <mat-icon matSuffix class="material-symbols-outlined nome-lock"
          matTooltip="Etapa padrão: nome bloqueado">lock</mat-icon>
        }
        <mat-hint align="end">{{ nome.length }}/{{ NOME_MAX_LENGTH }}</mat-hint>
      </mat-form-field>

      <div class="grid-2">
        <div>
          <span class="k-label">Cor</span>
          <div class="swatch-box">
            @for (c of cores; track c) {
            <button type="button" class="swatch" [class.swatch--active]="cor === c" [style.background-color]="c"
              [style.color]="c" (click)="selecionarCor(c)" [attr.aria-pressed]="cor === c"
              [attr.aria-label]="'Cor ' + c" [matTooltip]="c"></button>
            }
          </div>
        </div>
        <div>
          <span class="k-label">Ícone</span>
          <div class="swatch-box">
            @for (ic of icones; track ic) {
            <button type="button" class="icon-swatch" [class.icon-swatch--active]="icone === ic"
              (click)="selecionarIcone(ic)" [attr.aria-pressed]="icone === ic" [matTooltip]="ic">
              <mat-icon class="material-symbols-outlined">{{ ic }}</mat-icon>
            </button>
            }
          </div>
        </div>
      </div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Descrição interna</mat-label>
        <textarea matInput rows="2" [(ngModel)]="descricao"
          placeholder="Explique brevemente o que acontece nesta etapa."></textarea>
        <mat-hint>Tooltip de ajuda exibida ao operador no board</mat-hint>
      </mat-form-field>
    </section>

    <!-- 2. Campos da etapa -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">2</span>
        <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
        <span>Campos da etapa</span>
        <div class="section-title-actions ms-auto">
          <button mat-button type="button" class="btn-section" (click)="adicionarCampo()">
            <mat-icon class="material-symbols-outlined">add</mat-icon>
            Adicionar campo
          </button>
        </div>
      </div>
      <p class="section-sub-title">Informações que o card deve receber enquanto estiver nesta etapa.</p>

      @if (isEncerrado) {
      <app-alert-card type="warning" icon="flag">
        <span>
          <strong>Resultado</strong> e <strong>Motivo</strong> são obrigatórios nesta etapa e não podem ser excluídos.
          Cadastre ao menos uma opção em cada antes de liberar o uso operacional.
        </span>
      </app-alert-card>
      }

      @if (campos.length === 0) {
      <div class="empty-inline">Nenhum campo configurado. Os cards desta etapa terão apenas os campos globais.</div>
      }

      <div class="campos-list" cdkDropList (cdkDropListDropped)="reordenarCampos($event)">
        @for (campo of campos; track $index) {
        <div class="campo-row" [class.campo-row--essencial]="!!campo.isEssencial" cdkDrag>
          <span class="campo-handle" cdkDragHandle matTooltip="Arraste para reordenar">
            <mat-icon class="material-symbols-outlined">drag_indicator</mat-icon>
          </span>

          <!-- Tooltip no form-field: o input desabilitado não dispara eventos de mouse. -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-nome"
            [matTooltip]="campo.isEssencial ? 'Campo essencial: o nome não pode ser alterado.' : ''">
            <input matInput [(ngModel)]="campo.nome" placeholder="Nome do campo" [disabled]="!!campo.isEssencial" />
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-tipo">
            <mat-select [(ngModel)]="campo.tipo" (ngModelChange)="onTipoCampoChange(campo)">
              @for (t of tiposCampo; track t.key) {
              <mat-option [value]="t.key">{{ t.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div class="campo-obrigatorio">
            <mat-slide-toggle class="app-toggle-compact" color="primary" [(ngModel)]="campo.obrigatorio"
              [disabled]="!!campo.isEssencial"
              [matTooltip]="campo.isEssencial ? 'Campo essencial: sempre obrigatório' : ''">
              Obrigatório
            </mat-slide-toggle>
          </div>

          @if (campo.isEssencial) {
          <span class="campo-action-spacer" matTooltip="Campo essencial da etapa: não pode ser excluído">
            <mat-icon class="material-symbols-outlined campo-essencial-lock">lock</mat-icon>
          </span>
          } @else {
          <button mat-icon-button type="button" matTooltip="Remover" (click)="removerCampo($index)">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
          }

          @if (isCampoComOpcoes(campo)) {
          <div class="campo-opcoes">
            <div class="campo-opcoes-head">
              <span>Opções do dropdown</span>
              <button mat-stroked-button type="button" class="campo-opcao-add" (click)="adicionarOpcao(campo)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>
                Adicionar opção
              </button>
            </div>
            @if (campo.opcoes.length === 0) {
            <div class="empty-inline">Nenhuma opção cadastrada.</div>
            }
            <div class="campo-opcoes-list">
              @for (opcao of campo.opcoes; track $index) {
              <div class="campo-opcao-row">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-opcao-input">
                  <input matInput [(ngModel)]="opcao.descricao" [placeholder]="'Opção ' + ($index + 1)" />
                </mat-form-field>
                <button mat-icon-button type="button" matTooltip="Remover opção" (click)="removerOpcao(campo, $index)">
                  <mat-icon class="material-symbols-outlined">close</mat-icon>
                </button>
              </div>
              }
            </div>
          </div>
          }

          @if (isCampoVinculo(campo)) {
          <div class="campo-opcoes">
            <div class="campo-opcoes-head">
              <span>Entidade vinculada</span>
            </div>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="campo-vinculo">
              <mat-select [(ngModel)]="campo.idTipoEntidadeVinculo">
                @for (v of vinculoEntidades; track v.id) {
                <mat-option [value]="v.id">{{ v.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }
        </div>
        }
      </div>
    </section>

    <!-- 3. Movimentações permitidas -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">3</span>
        <mat-icon class="material-symbols-outlined">moving</mat-icon>
        <span>Movimentações permitidas</span>
      </div>
      <p class="section-sub-title">Clique num destino para liberar a saída do card a partir desta etapa.</p>

      @if (permiteMovimentacoes) {

      <app-alert-card type="warning" icon="moving">
        <span>
          A partir de <strong>{{ nome || 'esta etapa' }}</strong>, o card pode ir para
          <strong>{{ totalDestinos }} {{ totalDestinos === 1 ? 'destino' : 'destinos' }}</strong>.
        </span>
      </app-alert-card>

      @if (destinosPrincipais.length > 0) {
      <div class="sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">route</mat-icon>
          <span>Fluxo principal</span>
        </div>
        <div class="dest-list">
          @for (d of destinosPrincipais; track d.etapa.idEtapaKanban) {
          <ng-container *ngTemplateOutlet="destinoRow; context: { d: d }"></ng-container>
          }
        </div>
      </div>
      }

      @if (destinosEspeciais.length > 0) {
      <div class="sub-section-container">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">alt_route</mat-icon>
          <span>Estados especiais</span>
        </div>
        <div class="dest-list">
          @for (d of destinosEspeciais; track d.etapa.idEtapaKanban) {
          <ng-container *ngTemplateOutlet="destinoRow; context: { d: d }"></ng-container>
          }
        </div>
      </div>
      }

      } @else {
      <div class="empty-inline">
        <mat-icon class="material-symbols-outlined">flag</mat-icon>
        Encerrado é a etapa terminal do fluxo e não possui movimentações de saída.
      </div>
      }
    </section>

    <!-- 4. Permissões por perfil -->
    <section class="section-container">
      <div class="section-title">
        <span class="status-badge badge-cinza">4</span>
        <mat-icon class="material-symbols-outlined">lock_person</mat-icon>
        <span>Permissões por perfil</span>
      </div>
      <p class="section-sub-title">Quem pode fazer o quê nesta etapa.</p>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-label>Filtrar perfil</mat-label>
        <mat-icon matIconPrefix class="material-symbols-outlined">search</mat-icon>
        <input matInput [(ngModel)]="filtroPerfil" placeholder="Filtrar perfil…" />
      </mat-form-field>

      <div class="matriz" [class.matriz--reabrir]="isEtapaFinal">
        <div class="matriz-head">
          <div class="matriz-th">Perfil</div>
          @for (a of acoesVisiveis; track a.key) {
          <div class="matriz-th matriz-th--acao" (click)="toggleColuna(a.key)">
            <mat-icon class="material-symbols-outlined">{{ a.icon }}</mat-icon>
            <span>{{ a.label }}</span>
            <mat-checkbox color="primary" [checked]="estadoColuna(a.key) === 'all'"
              [indeterminate]="estadoColuna(a.key) === 'some'" (change)="toggleColuna(a.key)"
              (click)="$event.stopPropagation()"></mat-checkbox>
          </div>
          }
        </div>

        @for (p of perfisFiltrados; track p.idPerfil) {
        <div class="matriz-row">
          <div class="matriz-perfil">
            <mat-icon class="material-symbols-outlined">shield_person</mat-icon> {{ p.nome }}
          </div>
          @for (a of acoesVisiveis; track a.key) {
          <div class="matriz-cell">
            <mat-checkbox color="primary" [checked]="!!permissoes[p.idPerfil]?.[a.key]"
              (change)="togglePermissao(p.idPerfil, a.key)"></mat-checkbox>
          </div>
          }
        </div>
        } @empty {
        <div class="empty-inline">Nenhum perfil encontrado para "{{ filtroPerfil }}".</div>
        }
      </div>

      <p class="matriz-hint">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        Perfis sem <strong>Visualizar</strong> não enxergam os cards desta etapa no board.
      </p>

      @if (isEtapaFinal) {
      <div class="sub-section-container reabertura-block">
        <div class="sub-section-title">
          <mat-icon class="material-symbols-outlined">restart_alt</mat-icon>
          <span>Reabertura</span>
        </div>
        <p class="sub-section-sub-title">
          Para onde o card volta quando um perfil autorizado reabre uma oportunidade encerrada.
        </p>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
          <mat-label>Ao reabrir, retornar para</mat-label>
          <mat-select [(ngModel)]="idEtapaRetornoReabertura" placeholder="Selecione a etapa de retorno">
            @for (e of etapasRetornoReabertura; track e.idEtapaKanban) {
            <mat-option [value]="e.idEtapaKanban">{{ e.nome }}</mat-option>
            }
          </mat-select>
          <mat-hint>Sem esta etapa definida, a ação de reabrir não fica disponível no board.</mat-hint>
        </mat-form-field>
      </div>
      }
    </section>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer">
    @if (!isNova) {
    <span class="excluir-tooltip-wrap"
      matTooltip="Esta é uma etapa padrão do fluxo e não pode ser excluída — apenas renomeada."
      [matTooltipDisabled]="!isEtapaPadrao">
      <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isEtapaPadrao || isSalvando"
        (click)="excluir()">
        <mat-icon class="material-symbols-outlined">delete</mat-icon> Excluir etapa
      </button>
    </span>
    }
    <span class="spacer"></span>
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()"
      [disabled]="isSalvando">Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary" (click)="salvar()"
      [disabled]="isCarregando || isSalvando">
      @if (isSalvando) {
      <mat-spinner diameter="20"></mat-spinner>
      } @else {
      <mat-icon class="material-symbols-outlined">check</mat-icon> Salvar etapa
      }
    </button>
  </mat-dialog-actions>
</div>

<!-- Linha de destino reaproveitada. Borda vermelha (padrão do Compras) marca o destino selecionado. -->
<ng-template #destinoRow let-d="d">
  <div class="dest-row" [class.dest-row--sel]="d.config.selecionado">
    <button type="button" class="dest-head" [attr.aria-pressed]="d.config.selecionado" (click)="toggleDestino(d)">
      <span class="dest-icone" [style.background-color]="d.etapa.tint" [style.border-color]="d.etapa.cor"
        [style.color]="d.etapa.cor">
        <mat-icon class="material-symbols-outlined">{{ d.etapa.icone }}</mat-icon>
      </span>
      <span class="dest-nome">{{ d.etapa.nome }}</span>
      @if (d.etapa.isEspecial) {
      <span class="status-badge badge-vermelho">Especial</span>
      }
      <span class="spacer"></span>
      <mat-checkbox color="primary" [checked]="d.config.selecionado" (click)="$event.stopPropagation()"
        (change)="toggleDestino(d)"></mat-checkbox>
    </button>

    @if (d.config.selecionado) {
    <div class="dest-perfis">
      <span class="dest-perfis-label">
        <mat-icon class="material-symbols-outlined">lock_person</mat-icon> Perfis autorizados a mover
      </span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
        <mat-select [(ngModel)]="d.config.perfis" multiple placeholder="Todos os perfis podem mover">
          @for (p of perfis; track p.idPerfil) {
          <mat-option [value]="p.idPerfil">{{ p.nome }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (d.config.perfis.length > 0) {
      <div class="dest-perfis-chips">
        @for (idPerfil of d.config.perfis; track idPerfil) {
        <app-ui-tag [text]="nomePerfil(idPerfil)" [bgColor]="'#b73232'" [closable]="true"
          (remove)="removerPerfilDestino(d, idPerfil)"></app-ui-tag>
        }
      </div>
      }
    </div>
    }
  </div>
</ng-template>
